export default "__VITE_ASSET__kq4B5M92__"